import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import { postApi } from "../../utils/api";
import { API_RAISE_CONCERN } from "../../config/Endpoints";
import { toast } from "react-toastify";
import axios from "axios";
import { getUser } from "../../utils/Storage";
import { TailSpin } from "react-loader-spinner";
import { API_MY_ATTANDANCE } from "../../config/Endpoints";
import DatePicker from "react-datepicker";
import * as Yup from "yup";
import validations from "../../config/validation";
const RaiseConcern = () => {
  const [formData, setFormData] = useState({
    concernDate: "",
    reason: "",
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = Cookies.get("accessToken");
  const userData = JSON.parse(getUser("userData"));
  console.log(userData);
  const [attendanceData, setAttendanceData] = useState(null);
  const [isAttendanceLoading, setIsAttendanceLoading] = useState(false);
  const today = new Date();
  const minDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  const maxDate = new Date();

  const fetchAttendance = async (selectedDate) => {
    try {
      setIsAttendanceLoading(true);
      const dateObj = new Date(selectedDate);
      const month = dateObj
        .toLocaleString("en-US", { month: "long" })
        .toUpperCase();
      const year = dateObj.getFullYear();

      const res = await axios.get(
        `${API_MY_ATTANDANCE}?month=${month}&year=${year}&empid=${userData?.id}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      const json = res.data;

      const day = dateObj.toLocaleString("en-US", { day: "2-digit" });
      const monthShort = dateObj.toLocaleString("en-US", { month: "short" });
      const weekDay = dateObj.toLocaleString("en-US", { weekday: "short" });

      const formattedDate = `${weekDay}, ${monthShort} ${day}`;

      const record = json.data.find((item) => item.date === formattedDate);

      setAttendanceData(record || null);
    } catch (error) {
      console.error(error);
      setAttendanceData(null);
    } finally {
      setIsAttendanceLoading(false);
    }
  };

  const handleInputChange = (event) => {
    const { name, value, type } = event.target;

    if (type === "date") {
      setFormData((prev) => ({ ...prev, [name]: value }));
      setAttendanceData(null);
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const validationSchema = Yup.object().shape({
    reason: validations.COMMENT_VALIDATION.min(
      5,
      "Minimum 5 characters are required."
    ).max(200, "Reason must not exceed 200 characters."),
  });

  useEffect(() => {
    if (formData.concernDate) {
      fetchAttendance(formData.concernDate);
    }
  }, [formData.concernDate]);

  const handleReset = () => {
    setFormData({
      concernDate: "",
      reason: "",
    });
    setAttendanceData(null);
    setIsAttendanceLoading(false);
    setIsLoading(false);
    setErrors({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await validationSchema.validate(formData, { abortEarly: false });
      setErrors({});
    } catch (validationError) {
      if (validationError.inner) {
        const fieldErrors = {};
        validationError.inner.forEach((err) => {
          fieldErrors[err.path] = err.message;
        });
        setErrors(fieldErrors);
      }
      return;
    }

    setIsLoading(true);
    try {
      const requestData = {
        concernDate: formData.concernDate + "T00:00:00",
        punchInTime:
          attendanceData?.punch_in_time === "NA"
            ? null
            : attendanceData?.punch_in_time,
        punchOutTime:
          attendanceData?.punch_in_out === "NA"
            ? null
            : attendanceData?.punch_in_out,
        totalHour:
          attendanceData?.total_hour === "NA"
            ? null
            : attendanceData?.total_hour,
        reason: formData.reason,
      };

      await postApi(API_RAISE_CONCERN, requestData, accessToken)
        .then((res) => {
          setIsLoading(false);
          const modalClose =
            document.getElementsByClassName(" cancel-modal")[0];
          modalClose.click();
          toast.success(
            res.data.message ||
              "A concern request has been successfully raised!",
            {
              position: toast.POSITION.TOP_RIGHT,
            }
          );
        })
        .catch((e) => {
          const errorMessage =
            e?.response?.data?.message ||
            "Something went wrong please try again!";

          toast.error(errorMessage, {
            position: toast.POSITION.TOP_RIGHT,
          });

          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
  };

  // Get today's date in the format yyyy-mm-dd
  // const today = new Date().toISOString().split("T")[0];

  return (
    <form onSubmit={handleSubmit}>
      <div className="modal-header">
        <h5 className="modal-title text-center flex" id="staticBackdropLabel">
          Raise Attendance Concern
        </h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          onClick={handleReset}
        ></button>
      </div>
      <div className="modal-body">
        <div className="row mt-3">
          <div className="col-md-2"></div>
          <div className="col-md-4">
            <label htmlFor="concernDate" className="has-asterisk">
              Concern Date
            </label>
          </div>
          <div className="col-md-4 ">
            <DatePicker
              showIcon
              toggleCalendarOnIconClick
              selected={
                formData.concernDate ? new Date(formData.concernDate) : null
              }
              onChange={(date) => {
                if (!date) return;

                const backendValue = date.toLocaleDateString("en-CA");
                handleInputChange({
                  target: {
                    name: "concernDate",
                    value: backendValue,
                    type: "date",
                  },
                });
              }}
              dateFormat="MM-dd-yyyy"
              minDate={minDate}
              maxDate={maxDate}
              className="border"
              placeholderText="mm/dd/yyyy"
              onKeyDown={(e) => {
                if (e.key !== "Backspace" && e.key !== "Delete")
                  e.preventDefault();
              }}
              required
            />
          </div>
          <div className="col-md-2"></div>
        </div>
        {isAttendanceLoading && (
          <div className="overlay">
            <div className="loader-container">
              <TailSpin
                height="100"
                width="100"
                radius="1"
                color="blue"
                ariaLabel="tail-spin-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              />
            </div>
          </div>
        )}

        {!isAttendanceLoading && attendanceData && (
          <div className="row mt-3">
            <div className="col-md-2"></div>
            <div className="col-md-4"></div>
            <div className="col-md-4">
              <div className="text-muted border p-2 rounded-3 attendance-info-box">
                <p className="mb-1">Punch In: {attendanceData.punch_in_time}</p>
                <p className="mb-1">Punch Out: {attendanceData.punch_in_out}</p>
                <p className="mb-1">Total Hours: {attendanceData.total_hour}</p>
              </div>
            </div>
          </div>
        )}

        <div className="row mt-3">
          <div className="col-md-2"></div>
          <div className="col-md-4">
            <label htmlFor="reason" className="has-asterisk">
              Brief Reason
            </label>
          </div>
          <div className="col-md-4 ">
            <textarea
              id="reason"
              name="reason"
              required
              value={formData.reason}
              onChange={handleInputChange}
              rows={3}
              cols={20}
              className="border"
              onKeyPress={(e) => {
                // Prevent adding space at the beginning
                if (e.charCode === 32 && e.target.selectionStart === 0) {
                  e.preventDefault();
                }
              }}
            ></textarea>
            {errors.reason && (
              <small className="text-danger">{errors.reason}</small>
            )}
          </div>
          <div className="col-md-2"></div>
        </div>
      </div>

      <div className="justify-content-center modal-footer">
        <button type="submit" className={`theme-button `}>
          {isLoading ? (
            <ThreeDots
              height="20"
              width="53"
              radius="9"
              color="white"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
          ) : (
            "Submit"
          )}
        </button>
        <button
          type="button"
          className="theme-button bg-grey mx-3 w-35 cancel-modal"
          data-bs-dismiss="modal"
          onClick={handleReset}
        >
          Cancel
        </button>
      </div>
    </form>
  );
};

export default RaiseConcern;
